let domain = 'https://v1pay.fenfenriji.com'
let imgHost = 'https://d.fenfenriji.com/pink/static_v1/images/'
//let imgHost = 'http://app.activity.ffrj.net/officialWebsite/src/assets/images/'
export {
    domain,
    imgHost
}



// WEBPACK FOOTER //
// ./src/env.js